<script lang="ts">
	import type { StructuredFooterData } from './types';
	import { SEOPoiCategories } from '$lib/components/pois/types';
	import { getPathLabel } from '$lib/i18n/routing';
	import { languageTag } from '$paraglide/runtime';
	import { getSegmentsLabel, segments2href, segments2route } from './linkSegments';
	import SEOFooterLinkBlock from './SEOFooterLinkBlock.svelte';

	interface Props {
		data: StructuredFooterData;
	}

	const { data }: Props = $props();

	const { addressLinks, currentAddress, rankedCitiesData, returnRoute } = $derived(data);
	const lang = languageTag();

	const addressLinkBlocks = $derived([
		{
			title: getPathLabel('/map', lang) ?? 'Map',
			prefix: ['map'],
		},
		{
			title: getPathLabel('/map/traffic', lang) ?? 'Traffic',
			prefix: ['map', 'traffic'],
		},
		...SEOPoiCategories
			// TODO: remove when EV service is available in SEO
			.filter(c => c !== 'EV_SERVICE')
			.map(c => ({
				title: getPathLabel(`/map/${c}`, lang) ?? c,
				prefix: ['map', c],
			})),
	]);

	const routeTitle = $derived(getPathLabel('/routes', lang) ?? 'Routes');
</script>

<section class="flex flex-col gap-0 p-0 m-0">
	{#if currentAddress}
		{@const title = getSegmentsLabel(currentAddress)}
		<SEOFooterLinkBlock
			{title}
			links={addressLinkBlocks.map(link => ({
				href: currentAddress ? segments2href(currentAddress, lang, link.prefix) : '',
				label: `${title} ${link.title}`,
			}))}
		/>
	{/if}
	{#if currentAddress && addressLinks}
		<SEOFooterLinkBlock
			title={routeTitle}
			links={addressLinks.map(link => ({
				href: currentAddress ? segments2route(currentAddress, link, lang) : '',
				label: currentAddress
					? `${routeTitle} ${getSegmentsLabel(currentAddress)} - ${getSegmentsLabel(link)}`
					: routeTitle,
			}))}
		/>
	{/if}
	{#if addressLinks}
		{#each addressLinkBlocks as { title, prefix } (title)}
			<SEOFooterLinkBlock
				{title}
				links={addressLinks.map(link => ({
					href: segments2href(link, lang, prefix),
					label: `${title} ${getSegmentsLabel(link)}`,
				}))}
			/>
		{/each}
	{/if}

	{#if currentAddress && rankedCitiesData?.links.length}
		<SEOFooterLinkBlock
			testid="seo-ranked-cities-block"
			title={rankedCitiesData.label}
			links={rankedCitiesData.links}
		/>
	{/if}

	{#if returnRoute}
		<SEOFooterLinkBlock
			testid="seo-return-route-block"
			title={returnRoute.label}
			links={returnRoute.links}
		/>
	{/if}
</section>
